export const getStyles = (theme) => ({
    mainContainer: {
        width: "100%",
        height: 'calc(100% - 10px)',
        marginBottom: "10px",
        borderTop: '1px solid #DEDEDE'
    },
    cardContainer: {
        height: "100%",
        width: '100%',
        overflowY: "auto",
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'center'
    },
    paraText: {
        fontSize: theme.typography.h6,
        fontWeight: 400,
    }
})